export default __webpack_public_path__ + "media/images/cta_blocks/contact_block-341c426d26df3afcaf23caa188d7e7d1.jpg";